import qs from 'query-string';

export default function(data = {}) {
    var keys = Object.keys(data);
    if(! keys.length) {
        return '';
    }

    var formmatedObj = {};
    keys.forEach(key => {
        var dataForKey = data[key];

        var isMomentObj = dataForKey && dataForKey._isAMomentObject;
        if(isMomentObj) {
            formmatedObj[key] = dataForKey.format('YYYY-MM-DD');
            return;
        }

        if(typeof dataForKey == 'boolean') {
            formmatedObj[key] = +dataForKey;
            return;
        }

        formmatedObj[key] = dataForKey;
    });
    return '?' + qs.stringify(formmatedObj);
}




// WEBPACK FOOTER //
// ./app/utils/getApiQueryStringFromData.js